import { render } from "./ControleDeProjetos.vue?vue&type=template&id=3e74419b&scoped=true"
import script from "./ControleDeProjetos.vue?vue&type=script&lang=js"
export * from "./ControleDeProjetos.vue?vue&type=script&lang=js"

import "./ControleDeProjetos.vue?vue&type=style&index=0&id=3e74419b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e74419b"]])

export default __exports__